const state = {
  menuId: 1,
  secondId:null,
};

const mutations = {
    SET_MENU_ID (state, val) {
        state.menuId = val;
    },
    SET_SECOND_ID (state, val) {
      state.secondId = val;
  },
  
};

const actions = {
    set_menu_id ({ commit }, val) {
        commit('SET_MENU_ID', val);
    },
    set_second_id ({ commit }, val) {
      commit('SET_SECOND_ID', val);
  },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
